var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section section--larger"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"motto is-relative"},[_c('span',[_vm._v("“")]),_vm._t("default"),_c('span',[_vm._v("”")])],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }